
import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { BaseService } from '../../../shared/services/base.service';
import { SummaryFinancialIncomeModel } from '../models/summary-financial-income.model';

@Injectable()
export class FinancialIncomeService extends BaseService<SummaryFinancialIncomeModel,SummaryFinancialIncomeModel> {
  constructor(http: HttpClient) {
    super(http, '/api/v2/financial-incomes');
  }

}
